<template>
    <div
        class="card relative flex w-full items-center justify-between overflow-hidden px-4 py-2 text-sm"
        data-test="pending-file"
    >
        <!-- The progress fill is the row's own background. -->
        <div
            v-if="file.status === 'uploading'"
            class="absolute inset-y-0 left-0 bg-muval-gray-6 transition-all duration-200"
            :style="{ width: file.percent + '%' }"
        ></div>
        <div class="relative z-10 flex min-w-0 items-center gap-4">
            <SvgIcon
                name="system-document"
                class="size-8 shrink-0 text-muval-gray-3"
            />
            <div class="flex min-w-0 flex-col">
                <span
                    class="truncate"
                    v-text="file.name"
                ></span>
                <span class="text-xs text-muval-gray-3">
                    <template v-if="file.status === 'uploading'">
                        {{ formatBytes(file.loaded) }} of {{ formatBytes(file.total) }}
                    </template>
                    <span
                        v-else-if="file.status === 'error'"
                        class="text-error"
                        >Upload failed</span
                    >
                    <span
                        v-else
                        class="animate-pulse"
                        >Preparing…</span
                    >
                </span>
            </div>
        </div>
        <div class="relative z-10 flex items-center gap-4">
            <MuvalButton
                v-if="file.status === 'error'"
                quaternary
                small
                @click="emit('retry')"
            >
                Retry
            </MuvalButton>
            <button
                type="button"
                class="text-muval-gray-4 transition-colors hover:text-error"
                aria-label="Remove file"
                @click="emit('dismiss')"
            >
                <SvgIcon
                    name="system-close"
                    class="size-3.5"
                />
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import MuvalButton from '@buttons/MuvalButton.vue';
import SvgIcon from '@components/utilities/SvgIcon.vue';
import { formatBytes, type PendingFile } from '@utilities/fileDisplay';

/** One in-flight upload, shared by every file list. */

defineProps<{ file: PendingFile }>();

const emit = defineEmits<{ retry: []; dismiss: [] }>();
</script>
